import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { PageLayout } from 'pds-witsmlstudio-core/components';
import { faShieldHalved, faUsers } from 'pds-witsmlstudio-core/icons/solid';

export default class PageLayoutComponent extends Component {
  @service session;

  <template>
    <PageLayout>
      <:header>{{t "app.header" htmlSafe=true}}</:header>

      <:menu as |menuItem|>
        {{#if this.session.isAdministrator}}
          <menuItem
            @icon={{faShieldHalved}}
            @title={{t "permissions.title"}}
            @route="permissions"
          />
          <menuItem
            @icon={{faUsers}}
            @title={{t "users.title"}}
            @route="users"
          />
        {{/if}}
      </:menu>

      <:content>
        {{yield to="content"}}
      </:content>
    </PageLayout>
  </template>
}
